import { useContext } from 'react';
import { layoutContext } from './context.js';
import { jsx } from 'react/jsx-runtime';
import { FloatingActionButtonsContextMenu } from './molecule.fab-button/menu.js';
import { SolidContextmenu } from './molecule.solid-button/trigger.js';
import { FloatingActionButtonsContextMenuButton } from './molecule.fab-button/button.js';
import { SolidContextMenuButton } from './molecule.solid-button/button.js';

function UniversalContextMenu(props) {
  const content = (() => {
    switch (props.layout) {
      case "solid":
        return /*#__PURE__*/jsx(SolidContextmenu, {
          ...props
        });
      case "fab":
        return /*#__PURE__*/jsx(FloatingActionButtonsContextMenu, {
          ...props
        });
      default:
        return null;
    }
  })();
  return /*#__PURE__*/jsx(layoutContext.Provider, {
    value: props.layout,
    children: content
  });
}
function UniversalContextMenuButton(props) {
  const layout = useContext(layoutContext);
  switch (props.layout ?? layout) {
    case "solid":
      return /*#__PURE__*/jsx(SolidContextMenuButton, {
        ...props,
        inContextMenu: !!layout,
        ref: props.ref
      });
    case "fab":
      return /*#__PURE__*/jsx(FloatingActionButtonsContextMenuButton, {
        ...props,
        inContextMenu: !!layout,
        ref: props.ref
      });
    default:
      return null;
  }
}

export { UniversalContextMenu, UniversalContextMenuButton };
//# sourceMappingURL=molecule.contextmenu.js.map
